import type { Team } from '@rundown-studio/types'

/**
 * Retrieves the team ID that matches the given team ID from a list of user teams.
 * If no match is found, it falls back to the ID of the first team in the list.
 * If the list is empty, it returns the provided team ID.
 *
 * @param {string} teamId - The ID of the team to match.
 * @param {Team[]} userTeams - An array of user team objects to search through.
 * @returns {string} - The matched team ID, the first team's ID if no match is found, or the input team ID if the list is empty.
 */
export const getValidTeamIdWithFallback = (
  teamId: string,
  userTeams: Team[],
) => {
  const matchedTeam = userTeams.find((team) => team?.id === teamId)

  return matchedTeam?.id ?? userTeams?.[0]?.id ?? teamId
}
